const translations = {
  "en": {
    "Auto-renew resumed.": "Auto-renew resumed.",
    "Manage": "Manage",
    "Manage on edwealth.ai": "Manage on edwealth.ai",
    "Resume auto-renew": "Resume auto-renew",
    "Turn off auto-renew": "Turn off auto-renew",
    "Update payment method": "Update payment method"
  },
  "zh-tw": {
    "Auto-renew resumed.": "自動續訂已恢復。",
    "Manage": "管理",
    "Manage on edwealth.ai": "在 edwealth.ai 管理",
    "Resume auto-renew": "恢復自動續訂",
    "Turn off auto-renew": "關閉自動續訂",
    "Update payment method": "更新付款方式"
  }
};

export default translations;
